import { WIZARD_STATUS_DEFAULT, WIZARD_STATUS_DONE } from './enums.generateCl';

export default (params) => {
  const {
    stateType,
    handleWizardData,
    handleAutoGenerateCl,
    setWizardAnimation,
    res,
  } = params;
  const defaultValues = {
    text: "Let Wisedoc's AI work its magic! Your resume details will be transformed into a standout cover letter",
    animate: false,
    show: true,
    showTimer: false,
    time: 100,
    buttons: [
      {
        type: 'button',
        text: 'Later',
        link: null,
        triggerFunction: () => {
          setWizardAnimation(false);
        },
      },
      {
        type: 'button',
        text: 'Proceed',
        link: null,
        triggerFunction: async () => {
          handleWizardData({
            text: 'Wizard at work: Crafting your Cover Letter from Resume...',
            animate: true,
            show: true,
            showTimer: true,
            buttons: [],
          });

          await handleAutoGenerateCl();
        },
      },
    ],
  };
  switch (stateType) {
    case WIZARD_STATUS_DEFAULT:
      return defaultValues;
    case WIZARD_STATUS_DONE:
      return {
        text: 'Your cover letter has generated successfully and saved in drive',
        animate: false,
        show: false,
        showTimer: false,
        buttons: [
          {
            type: 'button',
            text: 'Maybe later',
            link: null,
            triggerFunction: () => {
              setWizardAnimation(false);
              handleWizardData(defaultValues);
            },
          },
          {
            type: 'link',
            text: 'Open',
            link: `/documents/${res.coverLetterId}`,
            triggerFunction: () => {
              setWizardAnimation(false);
              handleWizardData(defaultValues);
            },
          },
        ],
      };
    default:
      return null;
  }
};
